import React from 'react';
import { useEffect, useState } from "react";
import "../component/css/childdetails.css";
import { sanitizeInput } from "../utils/sanitizeInput";
import { useDispatch, useSelector } from "react-redux";
import {
  updateFormData,
  submitFormData,
  updateSchoolDetails,
  updateKeywordLabels,
} from "../redux/actions";

import axios from "axios";
import { useParams } from "react-router-dom";
import Alert from "@mui/material/Alert";
import { DAYCARE_ID, SERVER_URL, SESSION_NAME } from "../config";
import CustomDateInput from "./helpers/CustomDateInput";
import CustomSelect from "./helpers/CustomSelect";

function Childdetails({ Forward }) {
  const { daycareId, daycareCode } = useParams();
  const currentDaycareId = daycareId && daycareCode ? `${daycareId}/${daycareCode}` : DAYCARE_ID;
  const [applicationID, setApplicationId] = useState("");
  const [errors, setErrors] = useState("");
  const [selectedSession, setSelectedSession] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [currentView, setCurrentView] = useState(1);
  const [age, setAge] = useState("");
  const [dob, setDob] = useState("");

  const [validSessionName, setSessionName] = useState(true);
  const [validSectionName, setSectionName] = useState(true);
  const [validFirstChildName, setValidFirstChildName] = useState(true);
  const [validLastChildName, setValidLastChildName] = useState(true);
  const [validDOB, setValidDOB] = useState(true);
  const [validAge, setValidAge] = useState(true);
  const [validGender, setValidGender] = useState(true);
  const [hasReloaded, setHasReloaded] = useState(false);


  const handleSessioNameBlur = (e) => {
    const inputValue = e.target.value;
    if (inputValue.trim() === "") {
      setSessionName(false)
      setValidationErrors(`Please select a ${keywordLabels?.session || "session"} to enroll your ${keywordLabels?.child || "child"}.`);
    }
    else {
      setSessionName(true)
      setErrs('')

    }
  };

  const handleSectionNameBlur = (e) => {
    const inputValue = e.target.value;
    if (inputValue.trim() === "") {
      setSectionName(false)
      setValidationErrors(`Please select a ${keywordLabels?.section || "section"} to enroll your ${keywordLabels?.child || "child"}.`);
    }
    else {
      setSectionName(true)
      setErrs('')

    }
  };


  const handleChildFirsNameBlur = (e) => {
    const inputValue = e.target.value;
    if (inputValue.trim() === "") {
      setValidFirstChildName(false)
      setValidationErrors(`Please provide ${keywordLabels?.child || "child"}'s first name.`);
    }
    else {
      setValidFirstChildName(true)
      setErrs('')

    }
  };

  const handleChildLastNameBlur = (e) => {
    const inputValue = e.target.value;
    if (inputValue.trim() === "") {
      setValidLastChildName(false)
      setValidationErrors(`Please provide ${keywordLabels?.child || "child"}'s last name.`);
    } else {
      setValidLastChildName(true)
      setErrs('')

    }
  };

  const handleDateOfBirthBlur = (e) => {
    const inputValue = e.target.value;
    if (inputValue.trim() === "") {
      setValidDOB(false)
      setValidationErrors(`Please provide ${keywordLabels?.child || "child"}'s date of birth.`);
    } else {
      setValidDOB(true)
      setErrs('')

    }
  };

  const handleAgeCalculateBlur = (e) => {
    const inputValue = e.target.value;
    if (inputValue.trim() === "") {
      setValidAge(false)
      setValidationErrors("Please Select Date Of birth For age calculation ?");
    } else {
      setValidAge(true)
      setErrs('')

    }
  };

  const handleGenderBlur = (e) => {
    const inputValue = e.target.value;
    if (inputValue.trim() === "") {
      setValidGender(false)
      setValidationErrors(`Please select ${keywordLabels?.child || "child"}'s Gender.`);
    } else {
      setValidGender(true)
      setErrs('')

    }
  };








  const schoolDetails = useSelector((state) => state.schoolDetails);
  const keywordLabels = useSelector((state) => state.keywordLabels);
  const handleChange = (event) => {
    setSelectedSession(event.target.value);
  };



  useEffect(() => {
    const dobYear = new Date(dob).getFullYear();
    const today = new Date().getFullYear();
    if (dobYear) {
      let years = today - dobYear;
      setAge(years);
      localStorage.setItem('age', years);
    }
    else {
      setAge('')

    }



  }, [dob]);

  useEffect(() => {
    const storedAge = localStorage.getItem('age');
    if (storedAge) {
      setAge(parseInt(storedAge));
    }

  }, []);

  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem('age'); // Remove the desired data from localStorage
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);


  useEffect(() => {
    const handleBeforeUnload = (e) => {
      localStorage.removeItem('age'); // Remove the desired data from localStorage      
    };

    // if (age.ctrlKey && age.shiftKey && age.key === 'R') 
    window.addEventListener('beforeunload', handleBeforeUnload);
    // window.location.reload(age);
    // window.location.reload(age);


    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      // window.location.reload(age);

    };
  }, []);

  // React.useEffect(() => {
  //   
  //   };

  //   // Add the event listener when the component mounts
  //   window.addEventListener('keydown', handleKeyDown);

  //   // Clean up the event listener when the component unmounts
  //   return () => {
  //     window.removeEventListener('keydown', handleKeyDown);
  //   };
  // }, []);



  const getApplicationId = async () => {
    try {
      if (!applicationID) {
        const { data } = await axios.get(
          `${SERVER_URL}getApplicationIdV2/${currentDaycareId}`
        );
        const obj = {
          target: {
            name: "applicationId",
            value: data.applicationID,
          },
        };
        handleInputChange(obj);
      }
    } catch (error) {
      // Prevent uncaught error from propagating
      console.clear(); // Clears red console if needed

      // Log to dev console only
      console.error("Error fetching application ID:", error.message);

      if (error.message === "Network Error") {
        setErrors("The server seems to be down. Please try again later.");
      } else {
        setErrors("Something went wrong. Please refresh and try again.");
      }
    }
  };

  useEffect(() => {
    getApplicationId();
  }, []);

  const handleFileSelect = () => {
    document.querySelector("#imageInput").addEventListener("change", (ev) => {
      if (ev.target.files.length === 0) {
        return;
      }
      const file = ev.target.files[0];
      setSelectedFile(file);
      const fileReader = new FileReader();
      fileReader.readAsBinaryString(file);
      fileReader.onload = () => {
        const binaryStr = fileReader.result;
        const obj = {
          target: {
            name: "childPhoto",
            value: binaryStr,
          },
        };
        handleInputChange(obj);
      };
    });
  };
  useEffect(() => {
    handleFileSelect();
  }, []);

  const handleFileUpload = async () => {
    document.getElementById("imageInput").click();
  };

  const dispatch = useDispatch();
  const formData = useSelector((state) => state.formData);
  const schooldata = useSelector((state) => {
    return state.schoolDetails;
  });
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const cleanedValue = sanitizeInput(value);
    dispatch(updateFormData({ [name]: cleanedValue }));
  };

  const [err, setErrs] = useState("");
  const [sessions, setSessions] = useState([]);
  const [sections, setSections] = useState([]);

  const setValidationErrors = (err) => {
    setErrs(err);
  };
  const getSchoolDetails = async () => {
    try {
      const { data } = await axios.get(
        `${SERVER_URL}enrollmentDetailsV2/${currentDaycareId}`
      );
      dispatch(updateSchoolDetails(data));
      if (data.keywordLabels) {
        dispatch(updateKeywordLabels(data.keywordLabels));
      }
      //console.log("data and sessions are: ", data, " AND ", data.sessions)
      setSessions(data.sessions);
      setSections(data.sections);
    } catch (error) {
      console.clear(); // Optional: cleans up console red errors in dev
      console.error("Error fetching school details:", error.message);

      if (error.message === "Network Error") {
        setErrors("Unable to connect to the server. Please check your connection or try again later.");
      } else {
        setErrors("Failed to load school details. Please try again.");
      }
    }
  };




  useEffect(() => {
    getSchoolDetails();
  }, []);

  const handleNext = () => {
    formData.age = age;
    const formValues = formData;


    switch (true) {
      case !formValues?.sessionId:
        return setValidationErrors(`Please select a ${keywordLabels?.session || "session"} to enroll your ${keywordLabels?.child || "child"}.`);

      case !formValues?.sectionId:
        return setValidationErrors(`Please select a ${keywordLabels?.section || "section"} to enroll your ${keywordLabels?.child || "child"}.`);
      case !formValues?.firstName:

        return setValidationErrors(
          `You must provide the first name of the ${keywordLabels?.child || "child"}.`
        );

      case !formValues?.lastName:
        return setValidationErrors(`You must provide last name of the ${keywordLabels?.child || "child"}.`);
      case !formValues?.dateOfBirth:
        return setValidationErrors("You must provide the date of birth.");
      case !formValues?.gender:
        return setValidationErrors(`You must specify with the ${keywordLabels?.child || "child"} gender.`);
      case !age == "0" && !age:
        return setValidationErrors("You must mention the age.");

    }

    Forward();
  };

  if (errors) {
    return (
      <section className="child-main-sec">
        <div className="main-sec">
          <div className="error-message">
            Warning: {errors}
            <button onClick={() => window.location.reload()} className="retry-btn">
              Retry
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="child-main-sec">
        <div className="main-sec">
          <div className="main-head">
            <h1 className="font-fmly font-fml">
              <span>{keywordLabels?.orgName || "Sparkle"}</span> {keywordLabels?.child || "Child"} Admission Form
            </h1>
            <span>{formData?.applicationId}</span>
          </div>
          <h5>
            {keywordLabels?.welcomeMessage?.map((line, index) => (
              <p key={index}>{line}</p>
            ))}
            {/* <p>{schooldata.addresses.address1}, {schooldata.addresses.city}</p> */}
          </h5>

          {/* head section */}
          <div className="head-sec">
            <div className="para-sec">
              <h3>Add {keywordLabels?.child || "Child"} Details</h3>


            </div>
          </div>
          <div style={{ minHeight: '20px' }}> {/* adjust height as needed */}
            {err.length !== 0 ? (
              <Alert severity="error" className="arror-find">
                {err}
              </Alert>
            ) : null}
          </div>
          {/* photo upload section */}

          <div className="p-uplod-sec">
            {/* <div className="pc-uplod crcl">
              {selectedFile ? (
                <img
                  className="img-user-uploaded"
                  src={URL.createObjectURL(selectedFile)}
                  alt=""
                />
              ) : (
                <svg
                  width="52"
                  className="img-user"
                  height="65"
                  viewBox="0 0 52 65"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_2_79)">
                    <path
                      d="M24.0796 65.4353C16.2668 65.4353 8.45389 65.4353 0.640911 65.4353C0.420278 65.4353 0.198134 65.4461 -0.0208788 65.428C-0.937537 65.3544 -1.43096 64.8404 -1.426 63.9224C-1.39273 57.7807 0.315851 52.1804 4.06931 47.2914C8.14071 41.9879 13.5107 38.7605 20.0929 37.7349C32.8324 35.7496 44.5725 43.1903 48.4036 55.5616C49.2078 58.1587 49.5867 60.8179 49.672 63.5276C49.7152 64.9133 49.2261 65.4345 47.8495 65.4348C39.9262 65.4366 32.0029 65.4367 24.0796 65.4353ZM24.054 62.6938H27.6941C33.8714 62.6938 40.0487 62.6859 46.226 62.7072C46.7926 62.7091 46.9045 62.5747 46.8571 62.0121C46.7337 60.5363 46.4983 59.072 46.153 57.6321C45.4614 54.7064 44.199 51.9473 42.4387 49.5145C40.6784 47.0816 38.4551 45.0232 35.8975 43.4583C33.3398 41.8934 30.4985 40.853 27.5378 40.3973C24.5772 39.9416 21.5559 40.0797 18.6487 40.8035C8.66513 43.2646 2.08232 51.9193 1.34731 61.9129C1.30011 62.5548 1.42528 62.7128 2.08167 62.7104C9.40576 62.6842 16.7296 62.6938 24.054 62.6938Z"
                      fill="#C8C8C8"
                    />
                    <path
                      d="M39.9982 17.5048C40.009 26.2898 32.9037 33.4286 24.1392 33.4392C22.0512 33.4457 19.9825 33.0376 18.0522 32.2384C16.1219 31.4393 14.3681 30.2648 12.8917 28.7826C11.4152 27.3004 10.2453 25.5397 9.44926 23.6019C8.6532 21.6641 8.2467 19.5873 8.25314 17.4912C8.26707 8.69332 15.3746 1.55747 24.1191 1.56213C32.8504 1.56701 39.9877 8.73245 39.9982 17.5048ZM24.1056 30.7386C31.3017 30.7516 37.2522 24.8338 37.2765 17.6402C37.3012 10.2967 31.4556 4.32663 24.223 4.31058C16.8872 4.29411 10.9583 10.1768 10.9356 17.494C10.9132 24.763 16.8422 30.7255 24.1056 30.7386Z"
                      fill="#C8C8C8"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2_79">
                      <rect
                        width="51.1006"
                        height="63.8757"
                        fill="white"
                        transform="translate(0.0769272 0.810654)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              )}*/}
            {/*}
              <div className="plus-curcle">
                <button onClick={handleFileUpload} className="plus">
                  +
                </button>
              </div> */}
            {/*  </div> */}

            {/* <div className="pc-uplod btn-padd"> */}

            <div>
              {/* <button onClick={handleFileUpload} className="button pdg back">
                Upload Photo
              </button> */}

              <input
                id="imageInput"
                accept=".jpeg, .jpg, .png"
                type="file"
                // onChange={}
                style={{ display: "none" }}
              />
            </div>
          </div>

          {/* name section .... form-selection-session*/}


          {/* Original code

          <div className="form-group inp-tell-3 gender-last-things inp-tell bbb">

            <label className='my-label'>Select Session *</label>
            <select
              className="input drop-down-inp"
              name="sessionId"
              value={formData?.sessionId}
              style={validSectionName ? {} : { border: '1px solid red' }}
              onChange={(e) => {
                handleInputChange(e);
              }}

              onBlur={(e) => {
                handleSessioNameBlur(e);
              }}

            >
             {/* <option >
                Select class
              </option>*/}
          {/*      <option disabled selected>
                <span id="span"> </span>
              </option>

              {sessions.map((e) => {
                return (
                  <option value={e._id}>
                    <div >
                      {/*  {e.sessionName} {e.status} */}
          {/*              {e.sessionName}
                    </div>
                  </option>
                  
                );
              })}
                <option>Others</option> 
            </select>

            {/* <p>Selected Session: {selectedSession}</p> */}
          {/*      </div>
            
          
          <div className="form-group inp-tell-3 gender-last-things inp-tell bbb">

            <label className='my-label'>Select Class *</label>
            <select
              className="input drop-down-inp"
              name="sectionId"
              value={formData?.sectionId}
              style={validSectionName ? {} : { border: '1px solid red' }}
              onChange={(e) => {
                handleInputChange(e);
              }}

              onBlur={(e) => {
                handleSessioNameBlur(e);
              }}

            >
             {/* <option >
                Select class
              </option>*/}
          {/*          <option disabled selected>
                <span id="span"> </span>
              </option>

              {sections.map((e) => {
                return (
                  <option value={e._id}>
                    <div >
                      {/*  {e.sessionName} {e.status} */}
          {/*                 {e.sectionName}
                    </div>
                  </option>
                  
                );
              })}
                <option>Others</option> 
            </select>

            {/* <p>Selected Session: {selectedSession}</p> */}
          {/*      </div>
              */}


          <div className="input-main  pdg">
            <div className="inp-tell-1 inp-tell">
              <label className='my-label'>Select {keywordLabels?.session || "Session"}*</label>
              <CustomSelect
                className="input drop-down-inp"
                name="sessionId"
                value={formData?.sessionId}
                style={validSessionName ? {} : { border: '1px solid red' }}
                onChange={(e) => {
                  handleInputChange(e);
                }}

                onBlur={(e) => {
                  handleSessioNameBlur(e);
                }}

              >
                {/* <option >
                Select class
              </option>*/}
                <option disabled selected>
                  <span id="span"> </span>
                </option>

                {sessions
                  .map((e) => (
                    <option key={e._id} value={e._id}>
                      {e.sessionName}
                      </option>
                  ))}
             {/*   <option>Other</option>*/}
              </CustomSelect>

              {/* <p>Selected Session: {selectedSession}</p> */}
            </div>


            <div className="inp-tell-1 inp-tell left">
              <label className='my-label'>Select {keywordLabels?.section || "Class"}*</label>
              <CustomSelect
                className="input drop-down-inp"
                name="sectionId"
                value={formData?.sectionId}
                style={validSectionName ? {} : { border: '1px solid red' }}
                onChange={(e) => {
                  handleInputChange(e);
                }}

                onBlur={(e) => {
                  handleSectionNameBlur(e);
                }}

              >
                {/* <option >
                Select class
              </option>*/}
                <option disabled selected>
                  <span id="span"> </span>
                </option>

                {sections.map((e) => {
                    return (
                    <option value={e._id}>
                      <div >
                        {/*  {e.sessionName} {e.status} */}
                        {e.sectionName}
                      </div>
                      </option>

                    );
                  })}
              </CustomSelect>

              {/* <p>Selected Session: {selectedSession}</p> */}
            </div>

          </div>




          <div className="input-main pdg">
            <div className="inp-tell-1  inp-tell bbb">

              <label className="my-label">{keywordLabels?.child || "Child"} First Name*</label>
              <input
                className="input childFirst"
                value={formData?.firstName}

                style={validFirstChildName ? {} : { border: '1px solid red' }}
                onChange={(e) => {
                  // e.target.value
                  handleInputChange(e);

                }}

                onBlur={(e) => {
                  handleChildFirsNameBlur(e);
                }}

                name="firstName"
                type="text"
              // placeholder="Child First Name *"
              />
            </div>



            <div className="inp-tell-1  inp-tell left bbb">
              <label className="my-label">{keywordLabels?.child || "Child"} Last Name*</label>
              <input
                className=" input childLast"
                value={formData?.lastName}
                style={validLastChildName ? {} : { border: '1px solid red' }}
                type="text"
                onChange={(e) => {
                  handleInputChange(e);
                }}
                onBlur={(e) => {
                  handleChildLastNameBlur(e);
                }}
                name="lastName"
              />
            </div>
          </div>

          <div className="input-main pdg">
            <div className="inp-tell-1 inp-tell">
              <label className="my-label">dob*</label>
              <CustomDateInput
                placeholder=""
                name="dateOfBirth"
                value={formData?.dateOfBirth}
                style={validDOB ? {} : { border: '1px solid red' }}
                onChange={(e) => {
                  setDob(e.target.value);
                  handleInputChange(e);
                }}
                onBlur={(e) => {
                  handleDateOfBirthBlur(e);
                }}
                className="input dob "
              />
            </div>
            {/*
            <div className="inp-tell-2 inp-tell bbb">
              <label className="my-label">Age *</label>
              <input
                name="age"
                type="text"
                value={age}
                style={validAge ? {} : { border: '1px solid red' }}

                // disabled
                placeholder="Total Age"
                onChange={(e) => {
                  handleInputChange(e);
                  // handleBeforeUnload(e);
                }}
                // onClick={(e)=>{
                // handleKeyDown();
                // }}
                onBlur={(e) => {
                  handleAgeCalculateBlur(e);
                }}
                className="input age"

              />
            </div> */}

            <div className="inp-tell-1 inp-tell left bbb">
              <label className="my-label"> Gender*</label>
              <CustomSelect
                name="gender"
                className="input"
                value={formData?.gender}
                style={validGender ? {} : { border: '1px solid red' }}

                onChange={(e) => {
                  handleInputChange(e);
                }}
                onBlur={(e) => {
                  handleGenderBlur(e);
                }}
              >
                <option disabled selected>
                  <span id="span"> </span>
                </option>
                <option value={"Male"}>Male</option>
                <option value={"Female"}>Female</option>
              </CustomSelect>
            </div>

          </div>

          {/* original gender 
          <div className=" inp-tell-3 gender-last-things inp-tell bbb">
            <label className="my-label"> Gender *</label>
            <select
              name="gender"
              className="input"
              defaultValue={formData?.gender}
              style={validGender ? {} : { border: '1px solid red' }}

              onChange={(e) => {
                handleInputChange(e);
              }}
              onBlur={(e) => {
                handleGenderBlur(e);
              }}
            >
              <option disabled selected>
                <span id="span"> </span>
              </option>
              <option value={"Male"}>Male</option>
              <option value={"Female"}>Female</option>
            </select>
          </div>
          */}

          <button
            className="button pdg"
            onClick={() => {
              handleNext();
            }}
          >
            Continue
          </button>
        </div>
      </section>
    </>
  );
}

export default Childdetails;
